import {mapState, mapMutations} from 'vuex'
import { getCookie } from '@/assets/utils/CommonUtil'
// import {getElementsByClass} from '@/assets/utils/dom'
export default {
  data () {
    return {
      loading: false, // 正在加载数据
      tableMinHeight: 0,
      tipContent: {
        1: '只有总负责人可导出数据' // 导出按钮提示
      },
      operationBatch: false // 是否是批量操作
    }
  },
  computed: {
    ...mapState({
      foldMenu: state => state.menus.foldMenu, // 是否折叠菜单
      permissionMajor: state => state.config.permissionMajor
    }),
    disabledButton () {
      return {
        1: this.pageType === 'databaseBasis' && +getCookie('role') !== 2
      }
    }
  },
  mounted () {
    // console.log(this.permissionMajor)
    // console.log('-----------------')
    // this.computedTableMinHeight()
    // // 窗口大小改变时 触发
    // this.resizeHandle.resize(() => {
    //   this.computedTableMinHeight()
    // })
  },
  methods: {
    ...mapMutations({
      setLoading: 'config/SET_LOADING'
    }),
    // 1. 计算表格最小高度
    // computedTableMinHeight() {
    //   let minHeight = 0
    //   const windowHeight = document.documentElement.clientHeight
    //   const topOptionConts = getElementsByClass('content--options')
    //   if (this.isFixed) {} else {
    //     if (topOptionConts && topOptionConts[0]) {
    //       minHeight = windowHeight - topOptionConts[0].clientHeight - 24
    //     }
    //     if (minHeight) {
    //       this.tableMinHeight = minHeight
    //     }
    //   }
    //   console.log(this.tableMinHeight)
    //   console.log('=-=-=-=')
    // },
    // 5.4 电子档案室 下的 数据增加 权限校验
    verifyPermission (list, guid) {
      const tempList = list || []

      // 下边可以注释，企业数据库已移交计价，使用iframe内嵌，一下逻辑已经用不到
      const role = +getCookie('role')
      // let page = ''
      // const reg = /^\/database\/basis\/([^/?&]+)(\/|$|\?)/
      // const matchArr = reg.exec(this.$route.path)
      // if (matchArr && matchArr.length > 1) {
      //   page = matchArr[1]
      // }
      // let professionGuid = guid || ''
      tempList.forEach((item) => {
        // if (item.professionGuid) {
        // professionGuid = item.professionGuid
        // }
        //  只针对 电子档案室下的数据 对普通员工 做操作权限校验； 总负责人、档案室负责人始终有权限
        if (this.pageType === 'databaseBasis' && role === 4) {
          // if (page === 'material') {
          //   // 企业 人材机数据
          //   if (this.permissionMajor[page]) {
          //     item.professionAllowed = true
          //   } else {
          //     item.professionAllowed = false
          //   }
          // } else {
          //   if (!professionGuid) {
          //     item.professionAllowed = true
          //   } else {
          //     if (page && this.permissionMajor[page] && this.permissionMajor[page][professionGuid]) {
          //       item.professionAllowed = true
          //     } else {
          //       item.professionAllowed = false
          //     }
          //     // 方案列表 企业组价数据 页面
          //     if (item.estiDetailList && item.estiDetailList.length) {
          //       item.estiDetailList = this.verifyPermission(item.estiDetailList, professionGuid)
          //     }
          //     // 定额列表 企业组价数据 页面
          //     if (item.normItem && item.normItem.length) {
          //       item.normItem = this.verifyPermission(item.normItem, professionGuid)
          //     }
          //     // 人材机列表 企业组价数据 页面
          //     if (item.resList && item.resList.length) {
          //       item.resList = this.verifyPermission(item.resList, professionGuid)
          //     }
          //   }
          // }
        } else {
          item.professionAllowed = true
        }
      })
      return tempList
    }
  },
  watch: {
    // isFixed () {
    //   this.computedTableMinHeight()
    // },
    loading () {
      console.log(this.loading)
      console.log('----------------')
      // this.setLoading({
      //   key: 'content',
      //   value: this.loading
      // })
    }
  }
}
